import React, { useState } from "react";
import styles from "../../styles/form/FormInput.module.css";

const FormInput = ( props ) => {
    const location = [
        "서울특별시", "경기도", "강원도", "부산광역시", "대구광역시", "인천광역시"
        , "대전광역시", "울산광역시", "경상북도", "경상남도", "충청북도", "충청남도"
        , "전라북도", "전라남도", "세종특별자치시", "제주특별자치도", "기타",
    ]
    const sales = [
        "월 2000만원 이상", "월 5000만원 이상", "월 1억 이상",
    ]

    const rows = [
        ["고객명", "text"],
        ["휴대폰", "text"],
        ["이메일", "email"],
        ["사업장 지역", "select", location],
        ["월 매출", "select", sales],
        ["신청 금액", "text"],
    ];

    const [rowAnswers, setRowAnswers] = useState(
        Array(rows.length).fill('') // 문항 개수만큼 빈 문자열로 초기화
    );
    
    // const [selectedRadio, setSelectedRadio] = useState('');
    // const handleRadioChange = (e) => {
    //     setSelectedRadio(e.target.value);
    // };

    const handleInputChange = (index, value) => {
        const updatedAnswers = [...rowAnswers]; // 상태 복사
        updatedAnswers[index] = value;
        setRowAnswers(updatedAnswers);
    };

    const handleClick = (e) => {
        
    }

    return (
        <>
            <form onSubmit={handleClick}>
                <table className={styles.styledTable}>
                    <tbody>
                        <>
                        {/* <tr>
                            <td className={styles.titleCell}>문의 사항</td>
                            <td className={styles.radioCell}>
                            <label>
                            <input 
                            type="radio" 
                            name="option" 
                            value="option1" 
                            checked={selectedRadio === 'option1'} 
                            onChange={handleRadioChange} 
                                    />
                                    상담 문의
                                </label>
                                <label>
                                <input 
                                type="radio" 
                                name="option" 
                                    value="option2" 
                                    checked={selectedRadio === 'option2'} 
                                    onChange={handleRadioChange} 
                                    />
                                    제휴 문의
                                    </label>
                                    <label>
                                    <input 
                                    type="radio" 
                                    name="option" 
                                    value="option3" 
                                    checked={selectedRadio === 'option3'} 
                                    onChange={handleRadioChange} 
                                    />
                                    광고 문의
                                </label>
                            </td>
                            </tr> */}
                        </>
                        <>
                        {rows.map((row, index) => (
                            <>
                            {
                            row[1] !== 'select' 
                                ? <tr key={`row ${index + 1}`} className={styles.inputColumn}>
                                    <td className={styles.titleCell}>{row[0]}</td>
                                    <td className={styles.inputCell}>
                                        <input 
                                            type={row[1]} value={rowAnswers[index]}
                                            onChange={(e) => handleInputChange(index, e.target.value)}
                                            required
                                            />
                                    </td>
                                </tr>
                                : <tr key={`row ${index + 1}`} className={styles.selectColumn}>
                                    <td className={styles.titleCell}>{row[0]}</td>
                                    <td className={styles.selectCell}>
                                    <select
                                        value={rowAnswers[index]}
                                        onChange={e => handleInputChange(index, e.target.value)}
                                    >
                                        {row[2].map((item, idx) => {
                                            return <option key={`rows ${idx + 1}`} value={idx + 1}>{item}</option> 
                                        })}
                                    </select>
                                    </td>
                                </tr>
                            }
                            </>
                        ))}
                        </>
                    </tbody>
                </table>

                <div className={styles.tableButton}>
                    <button type="submit">문의하기</button>
                </div>
            </form>
        </>
    )
}

export default FormInput;